import { memo } from 'react';

import SiteAccordion from 'components/site/site-accordion';
import RichTextRenderer, {
  ContentfulContent,
} from 'components/misc/rich-text-renderer';
import { createGlobalStyle } from 'styled-components';
import { mqLargeMin } from 'styled/tools/media-queries';
import { WithFontBody } from 'styles/commonCss';
import { mqSmallMin } from 'styled/tools/media-queries';

type PDS08CuriousProps = {
  questions: any;
};

const CuriousStyles = createGlobalStyle`
  .pds08-curious {
  display: block;
  background-color: #fff;
  padding: var(--spacing-48) 0;

  @media ${mqLargeMin} {
    padding: 80px 0 120px;
  }

  * {
    color: var(--text-primary);
  }
  > .container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    height: auto;
    position: relative;
  }
  > .container > h2 {
    font-size: 36px;
    width: 100%;
    span {
      font-size: 36px;
      font-weight: 300;
      line-height: 36px - 10;
    }
    @media ${mqLargeMin} {
      font-size: var(--font-size-1200);
      width: 30%;
      span {
        font-size: var(--font-size-1200);
        font-weight: 300;
        line-height: 42px;
      }
    }
  }
  > .container > h2 br {
    @media ${mqSmallMin} {
      display: none;
    }
  }

  .list {
    @media ${mqLargeMin} {
      margin: 0;
      width: 65%;
    }
    width: 100%;
    margin: var(--spacing-48) 0 0;
  }

  .site-accordion {
    border-color: var(--outline-neutral);
    border-right: 0;
    border-left: 0;
  }
  .site-accordion .head {
    padding: var(--font-size-300) 0;
    padding: 1.25rem 0;
  }
  .site-accordion .head .icon {
    margin: 0;
    @media ${mqLargeMin} {
      margin-right: 10px;
    }
  }
  .site-accordion .head .title {
    max-width: 90%;
  }
  .site-accordion .head .title h3 {
    ${WithFontBody}
    font-size: var(--font-size-400);
    font-weight: 500;
  }
  .site-accordion .container {
    padding: 0 0 var(--spacing-24) 0;
    border-top: 0;
  }
  .site-accordion .content {
    border-color: var(--outline-neutral);
    background: transparent;
  }
  .site-accordion .content p {
    margin: var(--spacing-8) 0 0;
    &:first-child {
      margin: 0;
    }
  }
}
`;

const PDS08Curious = ({ questions }: PDS08CuriousProps) => {
  const heading: ContentfulContent = {
    content: [
      // FIXME: the 'content' isn't a valid value
      // @ts-ignore
      {
        content: [
          {
            data: {},
            nodeType: 'text',
            marks: [],
            value: 'For the curious.',
          },
        ],
      },
    ],
    // FIXME: the 'nodeType' isn't a valid value
    // @ts-ignore
    nodeType: 'heading-2',
  };

  return (
    <section className='pds08-curious'>
      <CuriousStyles />
      <div id='learnmore' className='container'>
        {/* FIXME: Why is return type of Contentful not renderable? */}
        <RichTextRenderer content={heading} />
        <div className='list'>
          {questions &&
            questions.map((v, i) => {
              const val = v.fields;
              return (
                val && (
                  <SiteAccordion
                    index={i}
                    key={val.question}
                    title={`<h3>${val.question}</h3>`}
                    content={val.response}
                  />
                )
              );
            })}
        </div>
      </div>
    </section>
  );
};

export default memo(PDS08Curious);
